<style>
@media (max-width: 576px) {
  #emailApplicantModal .modal-content {
    margin: 10px;
    border-radius: 10px;
  }

  #emailApplicantModal .modal-header {
    padding: 1rem !important;
    justify-content: center;
  }

  #emailApplicantModal .modal-title img {
    width: 180px;
    max-width: 80%;
    height: auto;
  }

  #emailApplicantModal .modal-body {
    padding: 1.5rem !important;
  }

  #emailApplicantModal .btn {
    font-size: 14px;
    padding: 10px;
  }
}
.disabled-btn {
  pointer-events: none !important;
  opacity: 0.6;
}

</style>
<template>
    <!-- First Modal: Email Confirmation -->
    <div class="modal fade" id="emailApplicantModal" tabindex="-1" aria-labelledby="emailApplicantModalLabel" aria-hidden="true">
       <div class="modal-dialog modal-dialog-centered">
           <div class="modal-content py-3">
               <div class="modal-header px-5 border-0">
                   <h5 class="modal-title">
                       <img src="@/assets/Images/Logo/kims-logo.png" width="250">
                   </h5>
               </div>
               <div class="modal-body px-lg-5 text-center">
                  <p class="mb-4 text-start">Please confirm your Email address</p>
                  <div class="mb-3 text-start">
                    <input type="email" placeholder="example@gmail.com" v-model="reemail" 
                      :class="['form-control mb-3 custom-placeholder', { 'is-invalid': errors.reemail }]"
                    >
                    <small v-if="errors.reemail" class="text-danger">{{ errors.reemail }}</small>
                  </div>
                  <button type="button"
                          class="btn btn-danger w-100"
                          :disabled="hardLock"
                          @click="validationMain">
                      <span v-if="loading"><i class="fa fa-spinner fa-spin"></i> Processing...</span>
                      <span v-else>Confirm</span>
                  </button>

                  


                  
               </div>
           </div>
       </div>
    </div>
  <div id="preloader" v-if="entirePageLoading" style="position: fixed; top:0; left:0; width:100%; height:100%; background: rgba(255,255,255,0.8); z-index: 9999; display:flex; flex-direction:column; justify-content:center; align-items:center;">
    <img src="@/assets/Images/Logo/preloader.png" alt="Loading Image" style="width:100px;">
    <p>Loading...</p>
  </div>


</template>

<script>
import { ResponseBooking, GetRazorKey, LoadFormNumber, PaymentResponse } from "@/api/Post/payment.js";
import { useAgentStore } from '@/store/agent';
import Swal from 'sweetalert2';
export default {
  name: "VerifyEmailAddressModel",
  data() {
    return {
      errors: {},
      reemail: '',  
      email: '',     
      loading: false,
      entirePageLoading: false,
      agent_id: '',
      clicks: 0,
      modalInstance: null,
      mountedCount: 0,
      hardLock: false
    };
  },
  
  mounted() {
    this.mountedCount++;
    //console.log("mounted() called", this.mountedCount, "times");

    // ensure we only initialize once
    if (!this.modalInstance) {
      const modalEl = document.getElementById('emailApplicantModal');
      if (modalEl) {
        this.modalInstance = new bootstrap.Modal(modalEl, { backdrop: 'static', keyboard: false });
        this.modalInstance.show();
        // cleanly reset clicks when hidden
        modalEl.addEventListener('hidden.bs.modal', this.onModalHidden);
      }
    }
    this.getApplicantEmail();
  },
  unmounted() {
      // cleanup to prevent duplicate listeners when component unmounts/remounts
      const modalEl = document.getElementById('emailApplicantModal');
      if (modalEl) {
        modalEl.removeEventListener('hidden.bs.modal', this.onModalHidden);
      }
      if (this.modalInstance) {
        try { this.modalInstance.hide(); } catch(e) {}
        this.modalInstance = null;
      }
      //console.log("unmounted() cleanup done");
  },
  methods: {
    onModalHidden: function () {
      // reset click counter if user closes modal
      this.clicks = 0;
      // optionally reset loading as safety
      this.loading = false;
    },
    getApplicantEmail() {
      const applicantData = localStorage.getItem("bookingData");
      if (applicantData) {
        const applicant = JSON.parse(applicantData);
        this.email = applicant.email || '';  
      }
    },
    async validationMain() {
        if (this.loading) return;
        this.loading = true;         //  Show loader + disable button

        //console.log("Confirm clicked (but locked)");
        //await this.$nextTick();

        this.errors.reemail = '';

        //await new Promise(resolve => setTimeout(resolve, 50));

      
        if (!this.reemail.trim()) {
          this.errors.reemail = "Email is required.";
          this.loading = false;
          return;
        }
        if (!/^\S+@\S+\.\S+$/.test(this.reemail)) {
          this.errors.reemail = "Invalid email format.";
          this.loading = false;
          return;
        }
        if (this.reemail.trim().toLowerCase() !== this.email.trim().toLowerCase()) {
          this.errors.reemail = "Email addresses do not match.";
          this.loading = false;
          return;
        }
        ///console.log("Emails match and are valid:", this.reemail);
        //this.loading = true;
        this.errors.reemail = '';
        if (this.hardLock) return;   //  BLOCK every extra click
        this.hardLock = true;        //  LOCK immediately

        try {
          const applicantData = localStorage.getItem("bookingData");
          const savedSlot = localStorage.getItem("selectedSlot");

          const applicant = JSON.parse(applicantData);
          const selectedSlot = JSON.parse(savedSlot);

          if (!applicant || !selectedSlot) {
            this.errors.reemail = "Booking data not found.";
            this.loading = false;
            return;
          }

          const agentStore = useAgentStore(); 
          if (agentStore.agentDetails) {
              //console.log('Agent Details in mounted agent id:', agentStore.agentDetails?.user?.agent?.id);
              this.agent_id= agentStore.agentDetails?.user?.agent?.id;
          }
          ResponseBooking(
            selectedSlot.id,
            applicant.noOfAdult,
            applicant.noOfChildren,
            applicant.fullName,
            applicant.phone,
            applicant.email,
            null,
            this.agent_id,
            applicant.whatsapp_notification
          ).then(async (responseBookingData) => {
            try {
              const response = responseBookingData.data;

              if (!response.success) {
                this.errors.reemail = response.message || "Something went wrong.";
                return;
              }

              ///console.log("Response Booking Data:", responseBookingData.data);
              //$('#emailApplicantModal').modal('hide');
              const modalEl = document.getElementById('emailApplicantModal');
              const modalInstance = bootstrap.Modal.getInstance(modalEl);

              if (modalInstance) {
                  modalInstance.hide();
              }


              this.$emit('nextStep');

              const bookingDetails = response.details;
              ///console.log("bookingDetails:", bookingDetails);

              const keyRes = await GetRazorKey();
              const razorpayKey = keyRes.data.data.key;
              //console.log('Razorpay Key:', razorpayKey);

              //  Show SweetAlert loader before Razorpay opens
              const swalLoading = Swal.fire({
                title: 'Initializing Payment...',
                text: 'Please wait while we connect to Razorpay',
                allowOutsideClick: false,
                didOpen: () => {
                  Swal.showLoading();
                }
              });
              
              const options = {
                key: razorpayKey,
                //amount: bookingDetails.amount * 100,
                amount: Math.round(bookingDetails.amount * 100),
                currency: bookingDetails.currency,
                name: "KIMSHEALTH",
                description: "Visa Medical Slot Booking",
                order_id: bookingDetails.order_id,
                prefill: {
                  name: applicant.fullName,
                  email: applicant.email,
                  contact: applicant.phone
                },
                notes: {
                  booking_id: bookingDetails.booking_id
                },
                theme: {
                  color: "#FF0000"  // RED THEME
                },

                handler: async (paymentResponse) => {
                  ///console.log("Payment Success:", paymentResponse);
                  Swal.close(); 

                  try {
                    this.entirePageLoading = true;
                    
                    const entiti_id = this.$route.params.id;
                    ///console.log("entiti_id:", entiti_id);

                    const response = await PaymentResponse(
                      bookingDetails.booking_id,
                      bookingDetails.amount,
                      1, // Razorpay
                      paymentResponse.razorpay_order_id,
                      paymentResponse.razorpay_payment_id,
                      paymentResponse.razorpay_signature,
                    );

                    //console.log("Payment Response:", response.data);
                    const paymentData = response.data;

                    try {
                      const formResponse = await LoadFormNumber(entiti_id);
                      await new Promise(resolve => setTimeout(resolve, 50));

                      const formData = formResponse.data;
                      localStorage.removeItem('bookingbookingDetails');
                      localStorage.removeItem('bookingFormData');
                      localStorage.removeItem('bookingPayment');
                      localStorage.setItem('bookingbookingDetails', JSON.stringify(bookingDetails));
                      localStorage.setItem('bookingFormData', JSON.stringify(formData));
                      localStorage.setItem('bookingPayment', JSON.stringify(paymentData));

                      this.$emit('backToSummary', formData);
                    } catch (formError) {
                      this.$toast.error('Failed to load form!', {
                        position: 'top-right',
                        duration: 3000,
                      });
                      console.error(formError);
                    }

                  } catch (error) {
                    this.$toast.error('Payment failed or verification failed!', {
                      position: 'top-right',
                      duration: 3000,
                    });
                    console.error("Error:", error);
                  } finally {
                    this.entirePageLoading = false;
                  }
                },
                modal: {
                  ondismiss: () => {
                    Swal.close(); //  Close loader if user cancels Razorpay window
                  }
                },

              };
              //console.log('options :', options);
              const rzp = new Razorpay(options);
              Swal.close();
              // Payment failed listener
              rzp.on('payment.failed', function(response) {
                console.error('Payment Failed:', response.error);
                this.$toast.error('Payment failed! Please try again.', { position: 'top-right', duration: 3000 });
              }.bind(this));

              // Open Razorpay popup
              setTimeout(() => rzp.open(), 300);


            } catch (innerError) {
              this.errors.reemail = innerError.response?.data?.message || "Something went wrong during payment.";
              console.error("Inner Booking error:", innerError);
            }
          }).catch((apiError) => {
            const message = apiError?.response?.data?.message || "Booking request failed.";
            this.errors.reemail = message;
            //console.error("Booking error:", message);

            this.$toast.error(message, {position: 'top-right',duration: 3000,});
            // CLOSE MODAL FIRST
            const modalEl = document.getElementById('emailApplicantModal');
            const modalInstance = bootstrap.Modal.getInstance(modalEl);
            if (modalInstance) {
              modalInstance.hide();
            }
            // wait for modal animation to finish
            setTimeout(() => {this.$emit('backStep');}, 500);
          });

        } catch (outerError) {
          this.errors.reemail = "Invalid booking/session data.";
          console.error("Outer Booking error:", outerError);
        } finally {
          this.loading = false;
          //this.hardLock = false; 
        }

    },
    
  }
};
</script>
